module.exports = __webpack_public_path__ + "static/media/manoel-negraes.a5adcf45.jpeg";